import React, { useRef, useState, useEffect } from 'react';
import ReactToPrint from "react-to-print";
import "./istyles.css";
import JsBarcode from 'jsbarcode';  // Import JsBarcode
import { QRCodeSVG } from 'qrcode.react'; // Import QRCodeSVG instead of default

//import { QRCodeCanvas } from 'qrcode.react';  // Import QRCodeCanvas
// import BarcodeGenerator from './BarcodeGenerator';
//import BarcodeGenerator from './route_components/BarcodeGenerator';

// Component for the Full Invoice
const FullInvoice = React.forwardRef(({ invoice }, ref) => (
  <div ref={ref}>  
    <br></br>  
    <h1>Invoice #{invoice.id}</h1>
    <p>Customer: {invoice.customer}</p>
    <p>Total Amount: ${invoice.amount}</p>
    <p>Address: {invoice.address}</p>
  </div>
));

// Component for the Address Only
const AddressOnly = React.forwardRef(({ invoice }, ref) => (
  <div ref={ref}>
    <br></br><br></br>
    <h1>Address for Invoice #{invoice.id}</h1>
    <p>{invoice.address}</p>  


    <div className="page">
      <p>This is a paragraph that will be printed.</p>      
      <table className="print-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Age</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ทดสอบภาษาไทยปล้ำใจ</td>
            <td>30</td>
          </tr>
          <tr>
            <td>สั้นเมฆสั้น ๆ กษัตริย์คงมองดู</td>
            <td>28</td>
          </tr>
        </tbody>
      </table>
      </div>

      <div className="page">
      <p>This is a paragraph that will be printed2.</p>      
      <table className="print-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Age</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>John Doe</td>
            <td>50</td>
          </tr>
          <tr>
            <td>Jane Smith</td>
            <td>82</td>
          </tr>
          <tr>
            <td>Janes tones</td>
            <td>82</td>
          </tr>
        </tbody>
      </table>
      </div>
  </div>
));



  const PrintableBarcode = React.forwardRef((props, ref) => {
  const { barcodeValue } = props;
  const barcodeRef = useRef(null);  // Reference to the barcode SVG element
  const barcodeRef2 = useRef(null);  // Reference to the barcode SVG element

  // Generate the barcode using JsBarcode when the component mounts or updates
  useEffect(() => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, barcodeValue, {
        format: 'CODE128',  // Use CODE128 format
        displayValue: true,  // Show the text below the barcode
        lineColor: '#000000',  // Barcode color
        width: 1,  // Width of barcode lines
        height: 41,  // Height of the barcode
        fontSize: 14,  // Font size of the barcode text
        margin: 10,  // Margin around the barcode        
      });
    }
    if (barcodeRef2.current) {
      JsBarcode(barcodeRef2.current, '2331012022944683', {
        format: 'CODE128',  // Use CODE128 format
        displayValue: true,  // Show the text below the barcode
        lineColor: '#000000',  // Barcode color
        width: 1,  // Width of barcode lines
        height: 41,  // Height of the barcode
        fontSize: 14,  // Font size of the barcode text
        margin: 10,  // Margin around the barcode
      });
    }


  }, [barcodeValue]);
  
  
  return (
    <div ref={ref} style={{ textAlign: 'center', marginTop: '20px' }}>
      <h2>Print Barcode (Code128)</h2>
      <svg ref={barcodeRef}></svg> {/* SVG for rendering the barcode */}
      <svg ref={barcodeRef2}></svg> {/* SVG for rendering the barcode */}
      <img alt="description of image2" src="./PrintReceiptTH(1).aspx"/>


      <QRCodeSVG       
        value={"http://www.google.co.th"} // The text or URL for the QR code
        size={150} // The size of the QR code
        bgColor="#ffffff" // Background color
        fgColor="#000000" // Foreground color
        level="H" // Error correction level ('L', 'M', 'Q', 'H')
        includeMargin={true} // Adds a margin around the QR code
      />
    </div>
  );
});

// Component to be printed
const PrintableQRCode = React.forwardRef((props, ref) => {
  const { text } = props;
  return (
    <div ref={ref} style={{ textAlign: 'center', marginTop: '20px' }}>
      <h2>Print QR Code</h2>   
      <QRCodeSVG       
        value={text} // The text or URL for the QR code
        size={150} // The size of the QR code
        bgColor="#ffffff" // Background color
        fgColor="#000000" // Foreground color
        level="H" // Error correction level ('L', 'M', 'Q', 'H')
        includeMargin={true} // Adds a margin around the QR code
      />   
    </div>
  );
});

// The component you want to print
const MyComponent = React.forwardRef((props, ref) => {
//const MyLineChart = forwardRef(({data}, ref) => {  
  return (
    <div ref={ref}>

    {/* Diagonal Watermark */}
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%) rotate(-45deg)", // Rotate to diagonal
        fontSize: "50px",
        color: "rgba(0, 0, 0, 0.1)", // Semi-transparent
        zIndex: 0,
        whiteSpace: "nowrap",
        pointerEvents: "none", // Avoid interaction
      }}
    >
      WATERMARK
    </div>      
    
    {/* Watermark */}
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: "50px",
        color: "rgba(0, 0, 0, 0.1)", // Semi-transparent
        zIndex: 0,
        whiteSpace: "nowrap",
        pointerEvents: "none", // Avoid interaction
      }}
    >
      WATERMARK
    </div>
      
      
      
      <h1>Hello, this is the content to print!</h1>
      <div className="page">
      <p>This is a paragraph that will be printed.</p>       
      <table className="print-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Age</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ทดสอบภาษาไทยปล้ำใจ</td>
            <td>30</td>
          </tr>
          <tr>
            <td>สั้นเมฆสั้น ๆ กษัตริย์คงมองดู</td>
            <td>28</td>
          </tr>
        </tbody>
      </table>
      </div>

      <div className="page">
      <p>This is a paragraph that will be printed2.</p>      
      <table className="print-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Age</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>John Doe</td>
            <td>50</td>
          </tr>
          <tr>
            <td>Jane Smith</td>
            <td>82</td>
          </tr>
          <tr>
            <td>Janes tones</td>
            <td>82</td>
          </tr>
        </tbody>
      </table>
      </div>


    </div>
  );
});


const App_tid_pdf = () => {

  const [barcodeValue, setBarcodeValue] = useState('2000171742');  // Default barcode value
  //const [barcodeValue, setBarcodeValue] = useState('70000');  // Default barcode value
  // const [barcodeValue, setBarcodeValue] = useState('2331012022944683');  // Default barcode value
  const [text, setText] = useState('http://www.google.co.th');  // QR code content

  const componentRef = useRef();
  const componentRef2 = useRef();
  const componentRef3 = useRef();

  const fullInvoiceRefs = useRef([]);
  const addressOnlyRefs = useRef([]);

  // Sample invoice data
  const invoices = [
    { id: 1, customer: 'John Doe', amount: 150, address: '123 Main St, Springfield' },
    { id: 2, customer: 'Jane Smith', amount: 200, address: '456 Elm St, Shelbyville' },
    { id: 3, customer: 'Alice Brown', amount: 300, address: '789 Oak St, Ogdenville' },
    { id: 4, customer: 'honor magicV', amount: 1300, address: '999 village park min young' },
  ];

  // Initialize refs for each invoice row
  fullInvoiceRefs.current = invoices.map((_, i) => fullInvoiceRefs.current[i] || React.createRef());
  addressOnlyRefs.current = invoices.map((_, i) => addressOnlyRefs.current[i] || React.createRef());


  return (
    <div>
      <h1>React-to-Print Example</h1>

      { <ReactToPrint
        trigger={() => <button>Print this content!</button>}
        content={() => componentRef.current}
      /> }

      { <ReactToPrint
        trigger={() => <button>Print this content!</button>}
        content={() => componentRef2.current}
      /> }

      { <ReactToPrint
        trigger={() => <button>Print this content!</button>}
        content={() => componentRef3.current}
      /> }

      
      <MyComponent ref={componentRef} />       

      <PrintableBarcode ref={componentRef2} barcodeValue={barcodeValue} />

      <PrintableQRCode ref={componentRef3} text={text} />

      <table className="print-table">      
        <thead>
          <tr>
            <th>Invoice #</th>
            <th>Customer</th>
            <th>Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((invoice, index) => (
            <tr key={invoice.id}>
              <td>{invoice.id}</td>
              <td>{invoice.customer}</td>
              <td>${invoice.amount}</td>
              <td>
                {/* Print Full Invoice Button */}
                <ReactToPrint
                  trigger={() => <button>Print Invoice</button>}
                  content={() => fullInvoiceRefs.current[index].current}
                />
                {/* Print Address Only Button */}
                <ReactToPrint
                  trigger={() => <button>Print Address</button>}
                  content={() => addressOnlyRefs.current[index].current}
                />
                {/* Hidden Components */}
                <div style={{ display: 'none' }}>
                  <FullInvoice ref={fullInvoiceRefs.current[index]} invoice={invoice} />
                  <AddressOnly ref={addressOnlyRefs.current[index]} invoice={invoice} />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

     {/* ส่วน พิมพ์ใบ invoice */ }
     <br></br>
     <table border="0">
      <tr>
        <td><img height="99" src="./CU-Logo.gif" width="65"/></td>
        <td style={{"height": "81px", "width": "382px"}}>คณะพาณิชยศาสตร์และการบัญชี จุฬาลงกรณ์มหาวิทยาลัย หลักสูตรบริหารธุรกิจมหาบัณฑิต<br></br>
            <span style={{"font-size":"20pt","font-weight":"bold","height":"16px","width":"200px"}}>ใบแจ้งชำระเงิน</span></td>   
        <td>&nbsp;&nbsp;&nbsp;</td>
        <td>&nbsp;&nbsp;&nbsp;</td>
        <td>&nbsp;&nbsp;&nbsp;</td>
        <td>&nbsp;&nbsp;&nbsp;</td>
        <td valign="middle" nowrap=""><font face="Tahoma">Tax id :</font></td>     
        <td valign="middle" nowrap="">
									<div style={{"height":"20px","width":"104px","margin-left": "0px"}}>
          <img alt="description of image1" src="./PrintReceiptTH.aspx"/>
        </div></td>
      </tr>
     </table>

     <table border="0">
      <tr>
        <td nowrap="" style={{"width": "178px"}}><strong>รหัสประจำตัวประชาชน</strong></td>
        <td style={{"width":"199px"}}><span style={{"width":"96px"}}>3101202294468</span></td>        
        <td valign="middle" nowrap="" align="right" rowspan="5" style={{"WIDTH": "63px"}}>
						<p align="right"><font face="Tahoma">Ref :1 </font>
						</p>
				</td>
        <td valign="middle" nowrap="" align="left" rowspan="5">
						<div>
            <img alt="description of image2" src="./PrintReceiptTH(1).aspx"/>
            </div></td>
        

      </tr>
      <tr>
          <td style={{"width": "178px"}}><strong>ชื่อผู้สมัคร</strong></td>
          <td style={{"width":"199px"}}><span style={{"width":"168px"}}>นาย รักเรียน ต่อโท</span></td>        
      </tr>

      <tr>
					<td nowrap="" style={{"width": "178px"}}><strong>หมายเลขโทรศัพท์</strong></td>
					<td style={{"width":"199px"}}><span>02-6943531</span></td>
			</tr>

      <tr>
					<td nowrap="" style={{"width": "178px"}}><strong>หมายเลขโทรศัพท์มือถือ</strong></td>
					<td style={{"width":"199px"}}><span>081-6943531</span></td>
			</tr>
     
      <tr>
        <td nowrap="" style={{"width": "178px"}}><strong>หลักสูตร</strong></td>
        <td style={{"width":"199px"}}><span style={{"width":"168px"}}>CU-BEST ครั้งที่: 4/2567</span></td>
      </tr>
      
      <tr>
      <td nowrap="" style={{"width": "178px"}}><strong>วันที่ออกใบรับชำระเงิน</strong></td>
      <td style={{"width":"199px"}}><span style={{"width":"162px"}}>06-Dec-2024</span></td>
      <td valign="middle" nowrap="" align="right" rowspan="4" style={{"WIDTH": "63px"}}>
						<p align="right"><font face="Tahoma"> Ref :2</font></p>
					</td>
      <td valign="middle" nowrap="" align="left" rowspan="4">
			  <div>
          <img alt="description of image3" src="./PrintReceiptTH(2).aspx"/>
        </div></td>	
      </tr>

      <tr>
					<td style={{"width": "178px"}}><strong>ค่าสมัคร </strong>
					</td>
					<td style={{"width":"199px"}}><span style={{"width":"115px"}}>700.00 บาท</span></td>
				</tr>
				<tr>
					<td style={{"width": "178px"}}><strong>วันรับชำระเงินวันสุดท้าย</strong></td>
					<td style={{"width":"199px"}}><span>13-Nov-2025</span></td>
				</tr>
				<tr>
					<td style={{"width": "178px"}}></td>
					<td style={{"width":"199px"}}></td>
				</tr>

     </table>

     
     <div style={{"width": "688px"}}>     
     <u><b>เพื่อประโยชน์สำหรับผู้สมัครสอบ โปรดอ่าน ! :</b></u><br></br>
		    ----------------------------------------------------------<br></br>
        <b>การชำระเงิน</b> :<br></br>
        : นำใบแจ้งชำระเงิน (payment slip) นี้ไปชำระค่าสมัครสอบได้ที่ counter service หรือ
        7-11 ทุกสาขา ภายในช่วงเวลาที่เปิดรับสมัครเท่านั้น<u> เพื่อประโยชน์ของผู้สมัครเอง เมื่อชำระเงินแล้วให้ตรวจสอบความถูกต้องของข้อมูลหลังการชำระเงิน</u>
     โดยดูรายละเอียดจากใบรับชำระที่ได้จากทาง counterservice ดังนี้<br></br>
- ใบรับฝากชำระ ระบุ<b>"MBA จุฬาฯ"</b><br></br>
- ยอดรับชำระตรงตามยอดจำนวนค่าสมัครในใบแจ้งชำระเงิน<br></br>
- ยอดการชำระ 1 ใบ ต่อการชำระเงิน 1 รายการเท่านั้น ห้ามชำระรวมกัน <br></br>
-ใบรับฝากชำระเงินนี้ใช้สำหรับชำระเงินสำหรับการสมัครสอบ cubest ในรอบสอบตามที่ระบุด้านบนเท่านั้น การใช้ใบรับฝากชำระเงินของการสอบรอบอื่น ไม่ถือว่าเป็นการชำระเงิน<br></br>
<b>(ไม่รับชำระผ่านทางระบบชำระเงินอื่นๆ)</b><br></br>
หากพบว่ามีความผิดพลาดตามที่ระบุข้างต้น ขอให้แจ้งแก้ไขกับทาง Counter Service ทันที และทำการภายในกำหนดรับสมัครเท่านั้น หากพ้นกำหนดการรับสมัครแล้วขอสงวนสิทธิ์ไม่รับผิดชอบ และไม่เปิดให้ชำระเงินใหม่<br></br>
*หากผู้สมัครชำระเงินแล้ว จะไม่มีการคืนเงินค่าสมัครสอบไม่ว่าในกรณีใดๆก็ตาม ยกเว้นในกรณีที่มีความเปลี่ยนแปลงจากทางจุฬาลงกรณ์มหาวิทยาลัย<br></br>

*ขอสงวนสิทธิ์ในการตัดสิทธิ์สอบ และไม่คืนเงินค่าสมัคร หากผู้สมัครสอบชำระเงินหลังจากช่วงเวลาที่กำหนด หรือชำระเงินผิดช่องทางการชำระไม่ว่ากรณีใดๆทั้งสิ้น <br></br>
*ขอสงวนสิทธิในการไม่คืนเงินค่าสมัครที่เป็นส่วนเกินจากยอดค่าสมัครที่ระบุ ไม่ว่ากรณีใดๆทั้งสิ้น<br></br>

   <b>การตรวจสอบสถานะการชำระเงิน</b> :<br></br>
        : ผู้สมัครสามารถตรวจสอบสถานะการชำระเงินจากเว็บรับสมัครสอบ หลังจากที่ชำระเงินแล้วประมาณ 3-5วัน ทางระบบรับสมัครสอบCUBEST <br></br>
   <b>การตรวจสอบเลขที่นั่งสอบและห้องสอบ</b> :<br></br>
        : สามารถตรวจสอบเลขที่นั่งสอบ และห้องสอบ ได้จากเมนู "ประวัติการสมัคร" ตามวันเวลาที่ประกาศผังสอบไว้<br></br>
        : ผู้สมัครสามารถตรวจสอบเลขที่นั่งสอบและผังห้องสอบอีกครั้ง รวมถึงระเบียบข้อปฏิบัติในการสอบได้จาก หน้าประกาศเลขที่นั่งสอบในเว็บไซต์ mba.cbs.chula.ac.th<br></br>
        : หลักสูตรจะไม่มีการส่งบัตรประจำตัวสอบไปให้ ผู้สอบจะต้องใช้ "บัตรประจำตัวประชาชน" แสดงต่อเจ้าหน้าที่ในห้องสอบ<br></br>
<hr></hr>
		<b>ทางศูนย์ทดสอบไม่มีการออกใบเสร็จรับเงินค่าสมัครสอบ ผู้สมัครสามารถใช้ใบรับฝากชำระเงินจาก Counter Service แทนได้</b>

      
    </div>


{/* ส่วน พิมพ์ใบ สถานที่สอบ */ }

<div>									
						<table  border="0" cellspacing="1" cellpadding="1" style={{"WIDTH": "648px", "HEIGHT": "65px"}}>
							<tr>
								<td rowSpan = "4" style={{"WIDTH": "197px"}}><img height="99" src="./CU-Logo.gif" width="65"/></td>
                <tr>
                
                  <td align="center"><font face="Tahoma"><strong>แจ้งสถานที่สอบวิชาความถนัดทางธุรกิจ 
                              (CU-BEST)</strong></font></td>
                </tr>
                <tr>
											<td align="center"><font face="Tahoma"><strong>Examination Location 
														Announcement</strong></font></td>
								</tr>

                <tr>
											<td align="center"><font face="Tahoma"><strong>Chulalongkorn 
														University - Bussiness Entrance Scholastic Test</strong> </font>
											</td>
										</tr>

                <tr>
											<td align="center"><strong>ครั้งที่&nbsp;:&nbsp;</strong>
												<span>4/2567</span></td>
								</tr>
								              
              </tr>
            </table>
            
            <table style={{"WIDTH": "648px", "HEIGHT": "65px"}} cellSpacing="1" cellPadding="1"  align="left" border="0">
            <tr>
							<td align="left"><font face="Tahoma">Master Business Administration</font></td>
						</tr>
            <tr>
              <td align="left"><font face="Tahoma">Faculty of Commerce and</font></td>
            </tr>
            <tr>
              <td align="left">Accountancy</td>
            </tr>
            <tr>
              <td align="left"><font face="Tahoma">Chulalongkorn University </font>
              </td>
            </tr>
            <tr>
              <td align="left">
                Room&nbsp;506 ,50th Memorial Bld.
              </td>
            </tr>
            <tr>
              <td align="left"><font face="Tahoma">Phayathai Rd. Bangkok 10330</font></td>
          </tr>
            <tr>
              <td align="left"><font face="Tahoma">Thailand</font></td>
            </tr>
            <tr>
              <td align="left"><font face="Tahoma">Tel. (66)-2218-5717 to 8 </font>
              </td>
            </tr>
            <tr>
              <td align="left">Fax. 0-2255-3020</td>
            </tr>
            <tr>
              <td align="left"><font face="Tahoma">Website:- <a href="http://www.mbachula.info/">www.mbachula.info</a></font></td>
            </tr>

            </table>

            <table style={{marginLeft: "10px","WIDTH": "648px", "HEIGHT": "65px"}} cellSpacing="1" cellPadding="1"  align="left" border="0">
            <tr>
								<td align="right" style={{"width": "129px"}}><font face="Tahoma">ชื่อ-นามสกุล&nbsp;:</font></td>
								<td align="left"><span style={{"width":"320px"}}>นาย รักเรียน ต่อโท</span></td>
						</tr>
            <tr>
								<td align="right" style={{"width": "129px"}}><font face="Tahoma">วันที่สอบ&nbsp;:</font></td>
								<td align="left"><font face="Tahoma"><span style={{"width":"320px"}}>13 ธันวาคม 2567</span></font></td>
						</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}><font face="Tahoma">เลขประจำตัวสอบ&nbsp;:</font></td>
											<td align="left"><font face="Tahoma"><span style={{"width":"320px"}}>0150</span></font></td>
										</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}><font face="Tahoma">สถานที่ :</font></td>
											<td align="left"><font face="Tahoma">
													<span id="lblPlace" style={{"width":"320px"}}>คณะพาณิชยศาสตร์และการบัญชี</span></font></td>
										</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}><font face="Tahoma">ตึก :</font></td>
											<td align="left"><font face="Tahoma">
													<span style={{"width":"320px"}}>ไชยยศสมบัติ3</span></font></td>
										</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}><font face="Tahoma">ห้อง :</font></td>
											<td align="left"><font face="Tahoma">
													<span style={{"width":"320px"}}>204</span></font></td>
										</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}><font face="Tahoma">ชั้น&nbsp;:</font></td>
											<td align="left">
												<span style={{"width":"320px"}}>2</span></td>
										</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}><font face="Tahoma">เวลาสอบ&nbsp;:</font></td>
											<td align="left"><font face="Tahoma">9.00 - 12.00 น.</font></td>
										</tr>

            </table>
            
  <div style={{ clear: "both" }}></div> {/* Forces tbl3 to a new line */}

 <table style={{ "marginTop": "20px", "WIDTH": "237px"}} cellSpacing="1" cellPadding="1" border="0">
 <tr><td>
            <u>ระเบียบในการสอบ CU-BEST</u><br></br>
<b>โปรดดูรายละเอียดเกี่ยวกับการเข้าสอบเพิ่มเติมจากเว็ปไซด์หลักสูตร MBA : http://mba.cbs.chula.ac.th/</b><br></br>
 1. เวลาเริ่มสอบ 9.00 น. - 12.00 น.<br></br>
 2. ผู้ที่มาหลังจาก 9.30 น.จะไม่ได้รับอนุญาตให้เข้าห้องสอบ<br></br>
 3. ผู้เข้าสอบจะต้องนำบัตรประจำตัวประชาชนมาแสดง<br></br>
     เพื่อเป็นหลักฐานต่อเจ้าหน้าที่คุมสอบ หากไม่ได้นำมาจะ<br></br>
     ไม่ให้เข้าสอบโดยเด็ดขาด<br></br>
 4. ห้ามใช้เครื่องคำนวณทุกประเภท และปิดเครื่องมือสื่อสาร<br></br>
     ทุกชนิด<br></br>
 5. ต้องแต่งกายสุภาพในการเข้าสอบ<br></br>
 6. ไม่อนุญาติให้นำกระดาษใดๆเข้าไปยังโต๊ะที่นั่งสอบและ<br></br>
      ไม่อนุญาติให้นำเนื้อหาส่วนใดของข้อสอบออกจาก<br></br>
      ห้องสอบ "เด็ดขาด"<br></br>
 7. หากทุจริตในการสอบ จะโดนตัดสิทธิ์  ในการสอบ <br></br>
     CU-BEST ตลอดไป <br></br>
<b><u>ตรวจสถานที่สอบและแผนที่</u></b>
<a href="http://mba.cbs.chula.ac.th/wp-content/uploads/%E0%B9%81%E0%B8%9C%E0%B8%99%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%84%E0%B8%93%E0%B8%B0%E0%B8%9A%E0%B8%B1%E0%B8%8D%E0%B8%8A%E0%B8%B52022Nov-1.jpg">[แผนที่คณะพาณิชยศาสตร์และการบัญชี]</a>
<br></br>
<a href="http://mba.cbs.chula.ac.th/wp-content/uploads/mapfaculty_forpost.pdf">[ แผนที่ห้องภายในพื้นที่คณะพาณิชยศาสตร์และการบัญชีอาคารไชยยศสมบัติ และ อาคารอนุสรณ์50ปี ] </a>
<br></br>
<img src="./MBAmapbuilding.png" height="100px" width="100px"/>
</td>
</tr>
</table>
  
</div>   

{/* ส่วน พิมพ์ใบ ผลสอบคะแนนสอบ */ }
<div>	
<table  border="0" cellspacing="1" cellpadding="1" style={{"WIDTH": "648px", "HEIGHT": "65px"}}>
							<tr>
								<td rowSpan = "3" style={{"WIDTH": "197px"}}><img height="99" src="./CU-Logo.gif" width="65"/></td>
                <tr>
                
                  <td align="center"><font face="Tahoma"><strong>ผลสอบวิชาความถนัดทางธุรกิจ 
                              (CU-BEST)</strong></font></td>
                </tr>
               

                <tr>
											<td align="center"><font face="Tahoma"><strong>Chulalongkorn 
														University - Bussiness Entrance Scholastic Test</strong> </font>
											</td>
										</tr>

                <tr>
											<td align="center"><strong>ครั้งที่&nbsp;:&nbsp;</strong>
												<span>4/2567</span></td>
								</tr>
								              
              </tr>
</table>

<table style={{"WIDTH": "648px", "HEIGHT": "65px"}} cellSpacing="1" cellPadding="1"  align="left" border="0">
            <tr>
							<td align="left"><font face="Tahoma">หลักสูตรบริหารธุรกิจมหาบัณฑิต</font></td>
						</tr>
            <tr>
              <td align="left"><font face="Tahoma">คณะพาณิชยศาสตร์และการบัญชี จุฬาฯ</font></td>
            </tr>                      
            <tr>
              <td align="left">
                ห้อง 506 อาคารอนุสรณ์ 50 ปี
              </td>
            </tr>
            <tr>
              <td align="left"><font face="Tahoma">ถนนพญาไท กรุงเทพฯ 10330</font></td>
          </tr>           
            <tr>
              <td align="left"><font face="Tahoma">โทร. 0-22185717-8 </font>
              </td>
            </tr>
            <tr>
              <td align="left">แฟ็กซ์. 0-2255-302</td>
            </tr>
            <tr>
              <td align="left"><font face="Tahoma">Website:- <a href="http://www.mbachula.info/">www.mbachula.info</a></font></td>
            </tr>

            </table>

<table style={{marginLeft: "10px","WIDTH": "648px", "HEIGHT": "65px"}} cellSpacing="1" cellPadding="1"  align="left" border="0">
            <tr>
								<td align="right" style={{"width": "129px"}}><font face="Tahoma">ชื่อ-นามสกุล&nbsp;:</font></td>
								<td align="left"><span style={{"width":"320px"}}>นาย รักเรียน ต่อโท</span></td>
						</tr>
            <tr>
								<td align="right" style={{"width": "129px"}}><font face="Tahoma">วันที่สอบ&nbsp;:</font></td>
								<td align="left"><font face="Tahoma"><span style={{"width":"320px"}}>13 ธันวาคม 2567</span></font></td>
						</tr>
            <tr>
								<td align="right" style={{"width": "129px"}}><font face="Tahoma">วันหมดอายุ&nbsp;:</font></td>
								<td align="left"><font face="Tahoma"><span style={{"width":"320px"}}>13 ธันวาคม 2567</span></font></td>
						</tr>

            <tr>
                <td align="right" style={{"width": "129px"}}><font face="Tahoma">เลขที่นั่งสอบ&nbsp;:</font></td>
                <td align="left"><font face="Tahoma"><span style={{"width":"320px"}}>0150</span></font></td>
            </tr>
  </table>
            
  <div style={{ clear: "both" }}></div> {/* Forces tbl3 to a new line */}
  <br></br>

<table cellspacing="1" cellpadding="1" width="648px" align="left" border="1">
	<tr>
		<td align="center"><font face="Tahoma">&nbsp;</font></td>
		<td align="center"><font face="Tahoma">วิเคราะห์ธุรกิจ</font></td>
		<td align="center"><font face="Tahoma">คณิตศาสตร์</font></td>
		<td align="center"><font face="Tahoma">รวม</font></td>
	</tr>
	<tr>
		<td align="center"><font face="Tahoma">คะแนนรวม</font></td>
		<td align="center"><font face="Tahoma">
														<span style={{"width":"67px"}}>250</span></font></td>
		<td align="center"><font face="Tahoma">
														<span style={{"width":"67px"}}>250</span></font></td>
		<td align="center"><font face="Tahoma">
														<span style={{"width":"67px"}}>500</span></font></td>
	</tr>
	<tr>
		<td align="center"><font face="Tahoma">คะแนนที่ได้</font></td>
		<td align="center"><font face="Tahoma">
														<span style={{"width":"67px"}}>-</span></font></td>
		<td align="center"><font face="Tahoma">
														<span style={{"width":"67px"}}>-</span></font></td>
		<td align="center"><font face="Tahoma">
														<span style={{"width":"67px"}}>-</span>
													</font>
												</td>
	</tr>
</table>

</div>


      
      {
      /*              
      <MyComponent ref={componentRef} />       
      <PrintableQRCode ref={componentRef} text={text} />
      <PrintableBarcode ref={componentRef} barcodeValue={barcodeValue} />
      */
      }
      
    </div>
  );
};

export default App_tid_pdf;
